import React from 'react';
import { ShieldCheck } from '@phosphor-icons/react';

/**
 * Web of Trust "Verified Site" badge — built and styled by us instead of
 * relying on WOT's third-party loader script, which never painted the
 * shield/logo reliably in production. Visually mirrors their dark badge
 * (shield + "Verified Site" + "Trusted by WOT" + "See Report") and still
 * links out to the real public scorecard, so it stays truthful.
 */
export default function WotBadge() {
  return (
    <a
      href="https://www.mywot.com/scorecard/gabrieledenaro.com"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Web of Trust scorecard for gabrieledenaro.com"
      data-testid="wot-badge"
      className="group flex items-center gap-3 rounded-lg border border-line bg-white/[0.03] px-3 py-2 text-xs transition-colors hover:border-white/20 hover:bg-white/[0.06]"
    >
      <ShieldCheck size={22} weight="fill" className="shrink-0 text-emerald-400" />
      <div className="flex flex-col leading-tight">
        <span className="font-semibold text-text-primary">Verified Site</span>
        <span className="text-text-muted">
          Trusted by{' '}
          <span className="font-bold">
            <span className="text-red-500">W</span>
            <span className="text-emerald-400">O</span>
            <span className="text-red-500">T</span>
          </span>
        </span>
      </div>
      <div className="h-8 w-px bg-white/10" aria-hidden="true" />
      <span className="text-text-muted underline decoration-white/20 underline-offset-2 group-hover:text-accent">
        See Report
      </span>
    </a>
  );
}
